import React from "react";
import useTranslation from "../hooks/useTranslation";

export default function Translation({ tKey }: { tKey: string }) {
  const { t } = useTranslation();

  return <>{t(tKey)}</>;
}
